export default "__VITE_ASSET__D0X4G9oL__"